import { DeviceSearchResponse } from 'api/Responses/SearchResponses';
import { UseUserState } from 'store/user/useUser';
import { getRegionSpecificDescription } from './user.helpers';

export const formatPartDescription = (user: UseUserState, part: DeviceSearchResponse) => {
  if (!user.isAuthenticated) {
    return '';
  }

  const description = getRegionSpecificDescription(user.region, part.language_metadata) ?? part.description ?? '';
  const isDescriptionExists = description.length > 0;

  return part.code.concat(isDescriptionExists ? ` - ${description}` : '');
};
